export const WORDS = [
  'sharp',
  'blade',
  'steel',
  'grind',
  'belts',
  'spine',
  'heats',
  'burrs',
  'drill',
  'files',
  'shave',
  'kukri',
  'point',
  'tangs',
  'forge',
  'tanto',
  'razor',
  'slice',
  'belly',
  'sabre',
  'scale',
  'rivet',
  'choil',
  'bevel',
  'pivot',
  'screw',
  'bowie',
]
